"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadOriflameApp = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  maxWidth: '740px',
  margin: '0 auto'
}));
const CustomBox = (0, _mui.styled)(_mui.Box)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 'calc(100% - 30px)',
  maxWidth: '740px',
  background: theme.palette.common.white,
  padding: theme.spacing(6, 3),
  marginInline: 'auto',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    borderRadius: '10px',
    padding: theme.spacing(6)
  }
}));
const StyledHeadTitle2 = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(5),
  paddingInline: theme.spacing(3)
}));
const DownloadOriflameApp = props => {
  const {
    tenant,
    title,
    oriflameApp,
    oriflameAppInfo,
    mt
  } = props;
  const {
    isMobileOperatingSystem
  } = (0, _utils.useMobileOperatingSystem)();
  const {
    data: dynamicLink
  } = (0, _staticApiClientReact.useGetTenantDigitalCatalogueDynamiclink)(tenant, {
    fallbackToWeb: true,
    clientApplication: 'mv7'
  });
  const handleRedirectToApp = () => {
    if (dynamicLink?.link) {
      window.location.href = dynamicLink.link;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RootContainer, {
    children: isMobileOperatingSystem ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeadTitle2, {
        variant: "h6",
        marginTop: mt ?? 12,
        children: title
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomBox, {
        sx: {
          padding: {
            xs: '20px 15px',
            sm: '20px 30px'
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
            display: "flex",
            alignItems: "center",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
              sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '45px',
                height: '45px',
                background: '#9CDABC',
                borderRadius: '10px'
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Oriflame, {
                sx: {
                  color: '#fff',
                  fontSize: '30px'
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
              display: "flex",
              flexDirection: "column",
              marginLeft: 3,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "caption",
                sx: {
                  textTransform: 'uppercase',
                  fontWeight: 'bold'
                },
                children: oriflameApp
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "caption",
                sx: {
                  maxWidth: '140px'
                },
                children: oriflameAppInfo
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
            onClick: () => handleRedirectToApp(),
            variant: "contained",
            color: "secondary",
            size: "large",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Download, {
              sx: {
                fontSize: '27px'
              }
            })
          })]
        })
      })]
    }) : null
  });
};
exports.DownloadOriflameApp = DownloadOriflameApp;